import React from "react"
import { Grid2, IconButton } from "@mui/material"
import { PanelLeft as PanelLeftIcon, PanelRight as PanelRightIcon } from "lucide-react"

import useStyles from "@/components/Sidebar/Header/styles"
import { HeaderProps } from "../protocols"

export const Header = (props: HeaderProps) => {
	const { logo, collapsedLogo, variant, isCollapsed, onToggleCollapse } = props
	const classes = useStyles({ variant })
	const activeLogo = isCollapsed && collapsedLogo ? collapsedLogo : logo
	const headerSx = [classes.header, isCollapsed ? classes.headerCollapsed : classes.headerExpanded]

	return (
		<Grid2 size={12}>
			<Grid2
				container
				wrap="nowrap"
				alignItems="center"
				sx={headerSx}
			>
				<Grid2
					size={isCollapsed ? 12 : 4}
					sx={isCollapsed ? { display: "flex", justifyContent: "center" } : undefined}
				>
					{activeLogo}
				</Grid2>
				<Grid2>
					<IconButton onClick={onToggleCollapse} sx={classes.collapseToggle} aria-label={isCollapsed ? "Expandir menu" : "Colapsar menu"}>
						{isCollapsed ? <PanelRightIcon size={20} /> : <PanelLeftIcon size={20} />}
					</IconButton>
				</Grid2>
			</Grid2>
		</Grid2>
	)
}
